'use strict';

/*@ngInject*/
module.exports = function ($scope, $translate, $modal, supportedLanguages, $timeout, platform) {
    $translate.refresh();
    $scope.supportedLangauges = supportedLanguages;
    $scope.currentLanguage = $translate.use();
    $scope.platform = platform;
    $scope.currentPlatform = $scope.platform.os.family.toLowerCase();
    if ($scope.currentLanguage) {
        $scope.currentLanguage = $scope.currentLanguage.toLowerCase();
    } else {
        $timeout(function () {
            $scope.currentLanguage = 'en';
        }, 2000);
    }

    $scope.changeLanguage = function (languageKey) {
        $translate.use(languageKey);
        $scope.currentLanguage = languageKey.toLowerCase();
    };
    $scope.togglePicker = function () {
        $scope.isPickerVisible = !$scope.isPickerVisible;
    };
    $scope.showSystemRequirementsModal = function () {
        $modal.open({
            templateUrl: './views/_system-requirements.html'
        });
    };
};